import apiShared from '../api/SharedAPI';

const getAreas = async () => {
    const result = await apiShared.getAreas();
    return result;
};

export default {
    getAreas: getAreas,
}